<template>
  <Toast />
  <div class="card-header">
    <!-- <Toolbar class="mb-0">
      <template #start>
        <h4>Dashboard</h4>
      </template>
      <template #end>
        <label>Período</label>&nbsp;
        <Calendar id="periodo" aria-describedby="periodo-error" v-model="periodo.label" inputClass="bg-input"
          autocomplete="off" view="month" dateFormat="mm/yy" :showIcon="true" @date-select="selectPeriodo" />&nbsp;&nbsp;
      </template>
    </Toolbar> -->
  </div>
  <div class="card-body dashboard mt-2">
    <h4 class="row">Bienvenido!</h4>
  </div>
</template>

<script>
import useDashboards from '../../composables/home/dashboards';
import { ref, onMounted, computed } from 'vue';
import moment from 'moment'

export default {
  setup() {
    const {
      style_estado, 
      loading, 
      router,
      spin,
      kpiProdChart,
      kpiProdCant,
      kpiProdProm,
      kpiEdosVtasGet,
      kpiEdosVtas,
      kpiEdosVtasDet,
      kpiEdoVtasDetalles,
      kpiVtaUmedida,
      kpiVtaUm,
      kpiRecepProdMonto,
      kpiRecMnt,
      kpiRecPago,
      kpiRecepPago,
      kpiGastos,
      kpiClasifGastos,
      kpiCompraEdoPago,
      kpiCompraEdo

    } = useDashboards()

    const userLogged = window.Laravel.user
    const periodo = ref({})
    const lestado = ref('')
    const card_style = ref("color: #000 !important;border-color: #ccc; border-left-width: 4px; border-left-style: solid;background: #FFF;")

    let periodoSelected =  new Date()
    let _periodo

    const dPeriodo = () => {
      return router.currentRoute.value.params.periodo 
        ? router.currentRoute.value.params.periodo 
        : Number(new Date().getFullYear() + ('0' + (new Date().getMonth() + 1).toString()).slice(-2))
    }

    const selectPeriodo = (e) => {
      periodo.value.val = e !== undefined ? e.getFullYear() + ('0' + (e.getMonth() + 1).toString()).slice(-2) : dPeriodo();
      periodo.value.label = [periodo.value.val.toString().slice(-2), "/", periodo.value.val.toString().slice(0, 4)].join('');

      let arrDate = periodo.value.label.split("/");
      
      periodoSelected.setDate("01");
      periodoSelected.setMonth(arrDate[0].toString());
      periodoSelected.setFullYear(arrDate[1].toString());
      _periodo = periodo.value.val;

      // obtenerIndicadores()
    }

    const formatCurrency = (value, style = true) => {
      return style  ? new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP' }).format(Number(value))
                    : new Intl.NumberFormat('es-CL').format(Number(value))
    }

    const formatFecha = (value) => {
      return moment(value).format("DD-MM-YY")
    }

    const obtenerIndicadores = async() => {
      await kpiProdChart(periodo.value.label)
      await kpiEdosVtasGet(periodo.value.label)
      await kpiEdoVtasDetalles(periodo.value.label, '0')
      await kpiVtaUmedida(periodo.value.label)
      await kpiRecepProdMonto(periodo.value.label)
      await kpiRecepPago(periodo.value.label)
      await kpiClasifGastos(periodo.value.label)
      await kpiCompraEdoPago(periodo.value.label)
    }

    const edoVtasDet = async(estado) => {
      switch (estado) {
        case "PAGADA":
          lestado.value = "PAGADA"
          style_estado.value = "background: #28a745 !important;color:#FFF;"
          card_style.value = "color:#000 !important;border-color: #28a745; border-left-width: 4px; border-left-style: solid;background: #FFF;"
          break; !important
        case "PENDIENTE":
          lestado.value = "PENDIENTE"
          style_estado.value = "background: #d46c18!important;color:#000 !important;"
          card_style.value = "color:#000 !important;border-color: #c89551; border-left-width: 4px; border-left-style: solid;background: #FFF;"
          break;
        case "VENCIDA":
          lestado.value = "VENCIDA"
          style_estado.value = "background: #ef4444 !important;color:#FFF !important;"
          card_style.value = "color:#000 !important;border-color: #ef4444; border-left-width: 4px; border-left-style: solid;background: #FFF;"
          break;
        case "SESTADO":
          lestado.value = "SIN ESTADO"
          style_estado.value = "background: rgb(100, 181, 246) !important;color:#FFF !important;"
          card_style.value = "color:#000 !important;border-color: rgb(100, 181, 246); border-left-width: 4px; border-left-style: solid;background: #FFF;"
          break; 
        default:
          lestado.value = ""
          style_estado.value = "background: #ccc !important;color:#000 !important;"
          card_style.value = "color:#000 !important;border-color: #ccc; border-left-width: 4px; border-left-style: solid;background: #FFF;"
      }
      await kpiEdoVtasDetalles(periodo.value.label, estado)
    }

    const umedidaColor = (umedida) => {
      switch (umedida) {
        case "METRO3":
          return 'info'
        case "PULGADA":
          return 'success'
        case "MRUMA":
          return 'warning'
        case "UNIDAD":
          return 'danger'
        case "MM":
          return 'contrast'
        default:
          return 'secondary'
      }
    }         

    const totPagos = computed(() => {
      let monto_abono = 0;
      if(kpiEdosVtasDet.value)
        for(let ln of kpiEdosVtasDet.value)
          monto_abono += Number(ln.monto_abono)
      return formatCurrency(monto_abono, false)
    })      

    const totSaldos = computed(() => {
      let saldo = 0;
      if(kpiEdosVtasDet.value)
        for(let ln of kpiEdosVtasDet.value)
          saldo += Number(ln.saldo)
      return formatCurrency(saldo, false)
    })      

    const totTotal = computed(() => {
      let tcantidad = 0;
      if(kpiEdosVtasDet.value)
        for(let ln of kpiEdosVtasDet.value)
          tcantidad += Number(ln.total)
      return formatCurrency(tcantidad, false)
    })      

    const totTotalUM = computed(() => {
      let tcantidad = 0;
      if(kpiVtaUm.value)
        for(let ln of kpiVtaUm.value)
          tcantidad += Number(ln.monto)
      return formatCurrency(Math.round(tcantidad), false)
    })      

    const totCantidadUM = computed(() => {
      let tcantidad = 0;
      if(kpiVtaUm.value)
        for(let ln of kpiVtaUm.value)
          tcantidad += Number(ln.cantidad)
      return formatCurrency(tcantidad, false)
    })    

    onMounted(selectPeriodo)

    return {
      lestado,
      style_estado, 
      card_style,
      loading,        
      spin,
      userLogged,
      periodo,
      dPeriodo,
      selectPeriodo,
      periodoSelected,
      kpiProdChart,
      kpiProdCant,
      kpiProdProm,
      kpiEdosVtasGet,
      kpiEdosVtas,
      kpiEdosVtasDet,
      formatCurrency,
      formatFecha,
      kpiEdoVtasDetalles,
      edoVtasDet,
      totTotal,
      totCantidadUM,
      totTotalUM,
      kpiVtaUmedida,
      kpiVtaUm,
      umedidaColor,
      kpiRecepProdMonto,
      kpiRecMnt,
      kpiRecPago,
      kpiGastos,
      kpiClasifGastos,
      kpiCompraEdoPago,
      kpiCompraEdo,
      totPagos,
      totSaldos
    }
  }
}
</script>